import React from 'react'
import PropTypes from 'prop-types'
import Login from './Login'
import Iframe from '../Iframe'

import './style.css.scss'

const AUTH_URL = "https://accounts.google.com/CheckCookie?continue=https://www.google.com/intl/en/images/logos/accounts_logo.png&followup=https://www.google.com/intl/en/images/logos/accounts_logo.png&chtml=LoginDoneHtml&checkedDomains=youtube&checkConnection=youtube:291:1"

class Google extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoggedIn: false,
      isLoggingIn: false,
      isLoading: true
    }
  }

  onError = () => {
    this.setState({
      isLoggedIn: false,
      isLoggingIn: false,
      isLoading: false,
    })
  }

  onLoad = () => {
    this.setState({
      isLoggedIn: true,
      isLoggingIn: false,
      isLoading: false
    })
  }

  handleLogin = () => {
    this.setState({ isLoggingIn: true })
  }

  handleLoggedIn = () => {
    this.setState({ isLoggingIn: false, isLoading: true })
  }

  render() {
    const { item } = this.props

    return (
      <div className="google-container">
        {
          this.state.isLoading ?  (
            <img src={AUTH_URL} onLoad={this.onLoad} onError={this.onError} alt="Google item image" />
          ) : (
            this.state.isLoggedIn
              ? <Iframe src={item.link_url} title="Viewer: Google item" />
              : <Login
                  item={item}
                  isLoggingIn={this.state.isLoggingIn}
                  onLogin={this.handleLogin}
                  onDone={this.handleLoggedIn} />
          )
        }
      </div>
    )
  }
}

Google.propTypes = {
  item: PropTypes.object.isRequired
}

export default Google